import React, { useState } from "react";
import PokemonPictures from "./pokemons/PokemonPictures";
import abilitysData from "./pokemons/PokemonAbilitys";
import "./styles/Pokemons.css";
import Footer from "./Footer";

const Pokemons = () => {
  const [selectedPokemon, setSelectedPokemon] = useState(null);

  const handlePokemonClick = (id) => {
    const pokemonData = abilitysData.find((p) => p.id === id);
    setSelectedPokemon(pokemonData);
  };

  return (
    <div className="pokemons-container">
      {/* 🔹 Überschrift und Beschreibung */}
      <div className="pokemons-header">
        <h1>All Attacks in Pokémon Unite TFT</h1>
        <p>
          Here, we present all the attacks in the Chinese Pokémon Unite TFT mode.
          We've translated them into English so you can easily choose the best
          attacks for your Pokémon and team compositions. This way, you’ll always
          have the optimal strategy to dominate in Pokémon Unite TFT!
        </p>
      </div>

      <div className="pokemon-content">
        {/* 🔹 Linke Seite - Pokémon Liste */}
        <div className="pokemon-list">
          {PokemonPictures.map((pokemon) => (
            <div key={pokemon.id} className="pokemon-item" onClick={() => handlePokemonClick(pokemon.id)}>
              <img src={pokemon.images} alt={pokemon.name} className="pokemon-img" />
            </div>
          ))}
        </div>

        {/* 🔹 Rechte Seite - Details zum gewählten Pokémon */}
        <div className="pokemon-details">
          {selectedPokemon ? (
            <>
              <h2 className="details-title">{selectedPokemon.name} Abilities</h2>
              <p className="info-text"> {selectedPokemon.item}</p>
              <div className="pokemon-ability-container">
                <div className="ability-box">
                  
                  <img src={selectedPokemon.img[0]} alt="Ability 1" className="pokemon-ability-img" />
                  <p className="ability-text">{selectedPokemon.description1}</p>
                </div>
                <div className="ability-box">
                  <img src={selectedPokemon.img[1]} alt="Ability 2" className="pokemon-ability-img" />
                  <p className="ability-text">{selectedPokemon.description2}</p>
                </div>
                <div className="ability-box">
                  <img src={selectedPokemon.img[2]} alt="Ability 2" className="pokemon-ability-img" />
                  <p className="ability-text">{selectedPokemon.description3}</p>
                </div>
              </div>
            </>
          ) : (
            <p className="select-text">Select a Pokémon to see details</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Pokemons;
